import AsyncStorage from '@react-native-async-storage/async-storage';
import { API } from '../../utils';
import { Linking } from 'react-native';

export const getStipeSettings = async ()=>{
console.log('called')
     try {
         const response = await fetch(`${API.baseurl}${API.stripeSettings}`);
         console.log(`${API.baseurl}${API.stripeSettings}`)
         const data= await response.json()
     console.log(data)
         return data
     } catch (error) {
    console.log({error})
        return error
     }
}

export const getReceipt = async (id)=>{
    console.log(id)
    const sessionKey = await AsyncStorage.getItem("key");
    const userId = await AsyncStorage.getItem("id");
    console.log(`${API.baseurl}${API.receipt}?id=${userId}&session_key=${sessionKey}&subscription_id=${id}`)
    try {
        const response = await fetch(`${API.baseurl}${API.receipt}?id=${userId}&session_key=${sessionKey}&subscription_id=${id}`);
        const data= await response.json()
        Linking.openURL(data.data.invoice_url)
        console.log(data.data ,'duhasidjios')
       
        return data
    } catch (error) {
       console.log({error})
       return error
    }
}